import {isArchived, type ScanWorkstream} from './WorkstreamScanList';

export const UPDATE_DUE_LABEL = 'Update due';

// Days a workstream's status update is past due (0 when it isn't).
export const daysUpdatePastDue = (row: ScanWorkstream): number =>
  typeof row.status_update_needed === 'number'
    ? Math.max(0, row.status_update_needed)
    : row.status_update_needed
      ? 1
      : 0;

/**
 * A status update you owe: overdue on a workstream you're DRI of (others on it
 * can't post the update, so it isn't theirs to see as due). Archived ones never are.
 */
export const isUpdateDueForMe = (row: ScanWorkstream, myRole?: string | null): boolean =>
  myRole === 'dri' && daysUpdatePastDue(row) > 0 && !isArchived(row);

/** Rows you owe an update on (most overdue first), and the rest in their order. */
export const splitUpdateDue = <T extends ScanWorkstream>(
  rows: T[],
  roleOf: (row: T) => string | null | undefined
): {due: T[]; rest: T[]} => {
  const due = rows
    .filter((row) => isUpdateDueForMe(row, roleOf(row)))
    .sort((a, b) => daysUpdatePastDue(b) - daysUpdatePastDue(a) || a.name.localeCompare(b.name));
  const dueIds = new Set(due.map((row) => row.id));
  return {due, rest: rows.filter((row) => !dueIds.has(row.id))};
};
